import React, { useEffect, useRef, useState } from 'react';
import { /*Button,*/ Col, Form, Row } from 'react-bootstrap';
import { ContinuosReportingType } from '../ContinuosReporting';
import { updateStatementByProjectIdAndStatementId } from 'lib/api_ts/continuosReportingApi';
import { useLocation } from 'react-router-dom-v5-compat';
import { debounce } from '@mui/material';

type InputValuesType = {
	contextAndObjectives: string;
	expectedOutcomes: string;
	workPerformedAndResults: string;
	projectPolicyRelevance: string;
};
interface ContinuosReportingSummaryProps {
	data: ContinuosReportingType;
	state: 'DRAFT' | 'VALIDATED';
	activeKey: string;
	inputValues: InputValuesType;
	setInputValues: React.Dispatch<React.SetStateAction<InputValuesType>>;
	isCoordinator: boolean;
   isEnabledToView: boolean;
}

const ContinuosReportingSummary: React.FC<ContinuosReportingSummaryProps> = ({
	data,
	state,
	activeKey,
	inputValues,
	setInputValues,
	isCoordinator,
   isEnabledToView,
}) => {
	const { pathname } = useLocation();
	const projectId = pathname.split('/')[2];

	const fields = [
		{
			name: 'contextAndObjectives',
			label: 'Contesto e principali obiettivi',
		},
		{
			name: 'expectedOutcomes',
			label: 'Lavoro svolto e principali risultati ottenuti',
		},
		{ name: 'workPerformedAndResults', label: 'Risultati attesi' },
		{
			name: 'projectPolicyRelevance',
			label: 'Policy rilevanti per il progetto',
		},
	];

	// const [inputValues, setInputValues] = useState({
	//   contextAndObjectives: data.contextAndObjectives || "",
	//   expectedOutcomes: data.expectedOutcomes || "",
	//   workPerformedAndResults: data.workPerformedAndResults || "",
	//   projectPolicyRelevance: data.projectPolicyRelevance || "",
	//   note: data.note || "",
	// });

	const [fieldsToSubmit, setFieldsToSubmit] = useState({
		contextAndObjectives: '',
		expectedOutcomes: '',
		workPerformedAndResults: '',
		projectPolicyRelevance: '',
		note: '',
	});

	const debouncedSetFieldsToSubmit = useRef(debounce((fieldsToSubmit) => setFieldsToSubmit(fieldsToSubmit), 500));

	useEffect(() => {
		debouncedSetFieldsToSubmit.current(inputValues);
	}, [inputValues]);

	const isModifiedRef = useRef(false);

	useEffect(() => {
		if (!isModifiedRef.current) return;
		if (activeKey !== 'summary') return;
		(async () => {
			try {
				await updateStatementByProjectIdAndStatementId(projectId, data.id, {
					statementTypeCode: 'CR',
					contextAndObjectives: fieldsToSubmit.contextAndObjectives,
					expectedOutcomes: fieldsToSubmit.expectedOutcomes,
					workPerformedAndResults: fieldsToSubmit.workPerformedAndResults,
					projectPolicyRelevance: fieldsToSubmit.projectPolicyRelevance,
				});
			} catch (error) {
				console.error('error', error);
			}
		})();
	}, [fieldsToSubmit, data, projectId, activeKey]);

	return (
		<Row>
			{fields.map((field) => (
				<Form.Group key={field.name} as={Col} xs={12} md={6} style={{ paddingInline: '20px', paddingBlock: '24px' }}>
					<Form.Label>{field.label}</Form.Label>
					<Form.Control
						as="textarea"
						rows={3}
						value={inputValues[field.name]}
						readOnly={!(isCoordinator || isEnabledToView)}
						onChange={(event) => {
							setInputValues((prevIninputValues) => ({
								...prevIninputValues,
								[field.name]: event.target.value,
							}));
							if (!isModifiedRef.current) isModifiedRef.current = true;
						}}
					/>
				</Form.Group>
			))}
		</Row>
	);
};

export default ContinuosReportingSummary;
